import { render, staticRenderFns } from "./form-order-consult.vue?vue&type=template&id=5a710a14&scoped=true"
import script from "./form-order-consult.vue?vue&type=script&lang=js"
export * from "./form-order-consult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a710a14",
  null
  
)

export default component.exports